<template>
    <v-input-text :value="inputValue" :label="label" :placeholder="placeholder" :disabled="disabled" :caption="caption"
        autocomplete="off" :error="error" :name="name" :theme="theme" :class="theme.isSelect" @focus="handleFocus"
        @assistant-outside-click="handleOutSideClick" @mouseleave.native="isInputEnter = false"
        @mouseenter.native="isInputEnter = true" @blur="handleBlur">
        <template slot="assistant-action" scope="props">
            <v-icon-button :class="theme.eventsNone">
                keyboard_arrow_down
            </v-icon-button>
        </template>

        <template slot="assistant" scope="props">

            <div v-if="isOpen" v-shadow="2" :class="theme.bgWhite">


                <div v-margin.bottom="1">
                    <v-input-text v-model="searchQuery" @input="handleSearch">
                        <template slot="prefix">
                            <template slot="assistant-action" scope="props">
                                <v-icon-button :class="theme.eventsNone">
                                    keyboard_arrow_down
                                </v-icon-button>
                            </template>
                        </template>
                    </v-input-text>
                </div>

                <div :class="theme.fixedHeight">
                    <div v-margin.bottom="1">
                        <v-checkbox v-if="altItem" v-model="altChecked" :data="altItem">
                            <v-text slot="label">
                                {{ altItem.name }}
                            </v-text>
                        </v-checkbox>
                    </div>
                    <div v-if="filteredItems.length === 0">
                        <div v-margin.bottom="1" v-for="(item, index) in items" :key="item.id || index">
                            <v-checkbox v-model="checked" :data="item">
                                <v-text slot="label">
                                    {{ item.name }}
                                </v-text>
                            </v-checkbox>
                        </div>
                    </div>
                    <div v-else>
                        <div v-margin.bottom="1" v-for="(item, index) in filteredItems" :key="item.id || index">
                            <v-checkbox v-model="checked" :data="item">
                                <v-text slot="label">
                                    {{ item.name }}
                                </v-text>
                            </v-checkbox>
                        </div>
                    </div>
                </div>

                <v-button primary @click="handleChoose"
                    :disabled="checked.length > maxSelectItems || (altChecked.length > 0 && checked.length > 0)">
                    выбрать
                </v-button>
            </div>
        </template>
    </v-input-text>
</template>

<script>
import { vButton, vIconButton } from '../Button';
import { vCheckboxRaw, vCheckbox } from '../Checkbox';
import { vInputText } from '../InputText';
import { vText } from '../Typography'
import { Margin } from '../../directives';
import theme from './inputMultiple.scss';

export default {
    name: 'input-multiple',
    directives: {
        Margin
    },
    components: {
        vCheckboxRaw,
        vCheckbox,
        vInputText,
        vIconButton,
        vButton,
        vText
    },
    props: {
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        items: {
            type: Array,
            default() {
                return []; // { id: Number, name: String }
            }
        },
        altItem: Object,
        maxSelectItems: Number,
        label: String,
        placeholder: String,
        disabled: Boolean,
        caption: String,
        error: String,
        name: String,
        maxlength: String,
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    data() {
        return {
            isActive: false,
            isFocused: false,
            isInputEnter: false,
            isOverAssistance: false,
            checked: [],
            altChecked: [],
            filteredItems: [],
            searchQuery: ""
        }
    },
    watch: {
        searchQuery(newValue) {
            this.searchQuery = newValue;
        }
    },
    computed: {
        isOpen() {
            return !this.disabled && this.isActive;
        },
        inputValue() {
            switch (true) {
                case typeof this.value !== 'object':
                    return undefined;
                case this.value.length === 1:
                    return this.value[0].name;
                case this.value.length > 1:
                    return 'Выбрано: ' + this.value.length;
                default:
                    return undefined;
            }
        }
    },
    methods: {
        handleBlur() {
            setTimeout(() => {
                this.isFocused = false;
            }, 150);
            this.$emit('blur');
        },
        handleFocus() {
            if (!this.disabled) {
                this.isActive = true;
            }
        },
        handleChoose() {
            this.$emit('input', this.altChecked.length > 0 ? this.altChecked : this.checked);
            this.isActive = false;
            this.$emit('blur');
        },
        handleOutSideClick() {
            if (!this.isInputEnter) {
                this.isActive = false;
            }
        },
        handleSearch() {
            if (this.searchQuery.trim() === '') {
                this.filteredItems = [...this.items];
                return;
            }

            const query = this.searchQuery.toLowerCase();

            this.filteredItems = this.items.filter(item => {
                const itemName = item.name || '';
                return itemName.toLowerCase().includes(query);
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// InputMultiple.vue?8cabd106